export default __webpack_public_path__ + "static/media/img11.9e853aa4.png";